<div class="col-lg-12 col-md-12 col-sm-10">
  <div class="card-container">
    <div class="card">
      <img [src]="brand.logoUrl" [alt]="brand.companyName" class="logo-image" />
      <div class="content">
        <h1>{{ brand.welcomeTitle }}</h1>
        <p>We are excited to have you on board!</p>

        <p *ngIf="showWarning" class="warning-message">
          Warning: You are not assigned to any user group. Please contact the
          administrator for assistance.
        </p>
      </div>
    </div>
  </div>
</div>
